import VProgressLinear from './VProgressLinear';

VProgressLinear.install = function install(Vue) {
  Vue.component(VProgressLinear.name, VProgressLinear);
};

export default VProgressLinear;


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VProgressLinear/index.js
// module id = pqui
// module chunks = 0